














































import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, toRef, computed } from '@vue/composition-api';
import { useFieldLayout } from '../store';
import { useInstance } from 'common-module/src/util/useInstance';

export default defineComponent({
  name: 'LayoutDrawerHead',
  setup(props, { emit }) {
    const store = useFieldLayout();
    const action = toRef(store, 'action');
    const issueType = computed(() => action.value?.issueType);
    const instance = useInstance();

    const onClose = () => {
      if (store.checkChanged()) {
        closeMsgBox();
        return;
      }
      emit('close');
    };

    const closeMsgBox = () => {
      return instance.$msgbox.confirm(
        instance.$t('project.issueType.unSave.message'), 
        instance.$t('project.issueType.unSave.title'), 
        {
          cancelButtonText: instance.$t('project.issueType.unSave.ignoreBtn'),
          confirmButtonText: instance.$t('button.save'),
          distinguishCancelAndClose: true,
          customClass: 'zk-auto-test_save-prompt',
          callback: async (action: 'cancel' | 'confirm') => {
            if (!['cancel', 'confirm'].includes(action)) {
              return;
            }
            if (action === 'confirm') {
              emit('save');
              return;
            }
            emit('close');
          }
        }
      );
    };

    return {
      action,
      issueType,
      firstProjectName: computed(() =>
        action.value?.projectName?.substring(0, 1).toUpperCase()
      ),
      onClose
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
